import { render, staticRenderFns } from "./GptDocumentsView.vue?vue&type=template&id=6292155c"
import script from "./GptDocumentsView.vue?vue&type=script&lang=js"
export * from "./GptDocumentsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports